import { gql } from '@apollo/client'

export const GENERATE_WITH_PROMPT = gql`
    mutation GenerateImage($input: GenerateImageInput!) {
        generateImage(input: $input) {
            id
            user_id
            url
            aspect_ratio
            prompt
            width
            height
            status
            error
            format
            name
            created_at
            updated_at
        }
    }
`

export const GENERATE_IMAGE_FROM_IMAGE = gql`
    mutation GenerateImageFromImage($input: GenerateImageFromImageInput!) {
        generateImageFromImage(input: $input) {
            id
            user_id
            url
            aspect_ratio
            prompt
            width
            height
            status
            error
            format
            name
            created_at
            updated_at
        }
    }
`

export const POLL_GENERATED_IMAGES = gql`
    query GeneratedImagesByIds($ids: [ID!]!) {
        generatedImagesByIds(ids: $ids) {
            id
            user_id
            url
            aspect_ratio
            prompt
            width
            height
            status
            error
            format
            name
            created_at
            updated_at
        }
    }
`

export const GENERATED_IMAGES = gql`
    query GeneratedImages {
        generatedImages {
            id
            user_id
            url
            aspect_ratio
            prompt
            width
            height
            status
            error
            format
            name
            created_at
            updated_at
        }
    }
`

export const DELETE_IMAGES = gql`
    mutation DeleteImages($ids: [ID!]!) {
        deleteImages(ids: $ids)
    }
`

export const GENERATE_VIDEO = gql`
    mutation GenerateVideo($input: GenerateVideoInput!) {
        generateVideo(input: $input) {
            id
            user_id
            url
            prompt
            format
            name
            status
            error
            duration_seconds
            created_at
            updated_at
        }
    }
`

export const POLL_GENERATED_VIDEOS = gql`
    query GeneratedVideosByIds($ids: [ID!]!) {
        generatedVideosByIds(ids: $ids) {
            id
            user_id
            url
            prompt
            format
            name
            status
            error
            duration_seconds
            created_at
            updated_at
        }
    }
`

export const GENERATED_VIDEOS = gql`
    query GeneratedVideos {
        generatedVideos {
            id
            user_id
            url
            prompt
            format
            name
            status
            error
            duration_seconds
            created_at
            updated_at
        }
    }
`

export const DELETE_GENERATED_VIDEOS = gql`
    mutation DeleteGeneratedVideos($ids: [ID!]!) {
        deleteGeneratedVideos(ids: $ids)
    }
`

export const MIRROR_AS_AD_CREATIVE_ASSET = gql`
    mutation MirrorAsAdCreativeAsset(
        $ids: [ID!]!
        $campaignId: String!
        $adId: ID
        $replaceExisting: Boolean
        $formats: [String]
        $allowMultiple: Boolean!
        $source: String
    ) {
        mirrorAsAdCreativeAsset(
            ids: $ids
            campaignId: $campaignId
            adId: $adId
            replaceExisting: $replaceExisting
            allowMultiple: $allowMultiple
            formats: $formats
            source: $source
        ) {
            id
        }
    }
`

const GENERATED_IMAGE_FIELDS = `
            id
            user_id
            url
            aspect_ratio
            prompt
            width
            height
            status
            error
            format
            name
            created_at
            updated_at
`

const GENERATED_VIDEO_FIELDS = `
            id
            user_id
            url
            prompt
            format
            name
            status
            error
            duration_seconds
            created_at
            updated_at
`

export const REFINE_GENERATED_IMAGE = gql`
    mutation RefineGeneratedImage($input: RefineGeneratedImageInput!) {
        refineGeneratedImage(input: $input) {
            revisedPrompt
            image {
                ${GENERATED_IMAGE_FIELDS}
            }
        }
    }
`

export const REFINE_GENERATED_VIDEO = gql`
    mutation RefineGeneratedVideo($input: RefineGeneratedVideoInput!) {
        refineGeneratedVideo(input: $input) {
            revisedPrompt
            video {
                ${GENERATED_VIDEO_FIELDS}
            }
        }
    }
`

// Unlike generatedImagesByIds this also returns a failed record, so a refine turn can report its failure
export const GENERATED_IMAGE_STATUS = gql`
    query GeneratedImageStatus($id: ID!) {
        generatedImageStatus(id: $id) {
            ${GENERATED_IMAGE_FIELDS}
        }
    }
`
